import { useState } from "react";
import HPContext from "./HPContext";

const HPState = (props) => {
  const [studyPrerequisiteMetaTags, setStudyPrerequisiteMetaTags] = useState([]);
  const [seriesConditionMetaTags, setSeriesConditionMetaTags] = useState([]);
  const [imageConditionMetaTags, setImageConditionMetaTags] = useState([]);
  const [conditionOperands, setConditionOperands] = useState([]);
  const [viewportFlipOptions, setViewportFlipOptions] = useState([]);
  const [viewportAlignmentOptions, setViewportAlignmentOptions] = useState([]);
  const [selectedTab, setSelectedTab] = useState("1");
  const [submitClicked, setSubmitClicked] = useState(true);

  return (
    <HPContext.Provider
      value={{
        studyPrerequisiteMetaTags, 
        seriesConditionMetaTags, 
        imageConditionMetaTags, 
        conditionOperands,
        viewportFlipOptions,
        viewportAlignmentOptions,
        selectedTab,
        submitClicked,
        setStudyPrerequisiteMetaTags,
        setSeriesConditionMetaTags,
        setImageConditionMetaTags,
        setConditionOperands,
        setViewportFlipOptions,
        setViewportAlignmentOptions,
        setSelectedTab,
        setSubmitClicked
      }}
    >
      {props.children}
    </HPContext.Provider>
  );
};

export default HPState;
